<template>
  <div
    v-if="vbAttachments && vbAttachments.length"
    class="content__message--fileAttachment content__message--item"
  >
    <div class="jobInfoAttachment">
      <div
        v-for="vbAttachment in vbAttachments"
        v-bind:key="vbAttachment.id"
        class="file-uploaded input-none__border"
      >
        <div class="file clickable flex-row flex__between padding-0">
          <a
            class="flex-row flex__left margin-left-10"
            @click="downloadFile(vbAttachment)"
          >
            <file-type-image
              :fileExtention="vbAttachment.fileExtention"
              :customClass="''"
            />
            <span class="">{{ vbAttachment.fileName }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import buildAttachmentURL from "../../../filters/buildAttachmentURL";
  import FileTypeImage from "../../job/FileTypeImage";

  export default {
    name: "history-attachments-template",
    components: {FileTypeImage},
    props: ["vbAttachments"],
    filters: {buildAttachmentURL},
    data() {
      return {};
    },

    methods: {
      downloadFile(vbAttachment) {
        this.$emit("downloadFile", {vbAttachment});
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/history-attachments-template.vue